import React, { FC, useCallback } from 'react';
import Modal, {
  Appearance,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from '@atlaskit/modal-dialog';
import Button from '@atlaskit/button';
import { translationKeys, useTranslation } from 'services/localization';
import { selectDoubleOptInDialog } from '../../preferencesSelectors';
import { showDoubleOptInDialog } from '../../preferencesSlice';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { trackDoubleOptInConfirmClick } from '../../services/userActionEvents';

const DoubleOptInDialog: FC = () => {
  const dispatch = useAppDispatch();
  const { translate } = useTranslation();
  const dialogPayload = useAppSelector(selectDoubleOptInDialog);

  const acceptHandler = useCallback(async () => {
    trackDoubleOptInConfirmClick();

    // Close dialog
    dispatch(showDoubleOptInDialog({ showDialog: false }));
  }, [dispatch]);

  const actions = [
    {
      text: translate(translationKeys.DOUBLE_OPT_IN_DIALOG_ACCEPT_BUTTON_LABEL),
      onClick: acceptHandler,
      autoFocus: true,
      appearance: 'primary' as Appearance,
      testId: 'double-opt-in-dialog-accept-button',
    },
  ];

  return (
    <ModalTransition>
      {dialogPayload.showDialog && (
        <Modal>
          <ModalHeader>
            <ModalTitle>{translate(translationKeys.DOUBLE_OPT_IN_DIALOG_LABEL)}</ModalTitle>
          </ModalHeader>
          <ModalBody>
            <p dangerouslySetInnerHTML={{ __html: translate(translationKeys.DOUBLE_OPT_IN_DIALOG_MESSAGE) }} />
          </ModalBody>
          <ModalFooter>
            {actions.map((a) => (
              <Button
                key={a.testId}
                appearance={a.appearance}
                onClick={a.onClick}
                autoFocus={a.autoFocus}
                testId={a.testId}
              >
                {a.text}
              </Button>
            ))}
          </ModalFooter>
        </Modal>
      )}
    </ModalTransition>
  );
};

export default DoubleOptInDialog;
